export enum NDEFType {
    TEXT = "TEXT",
    URL = "URL",
    APP = "APP"
}

